import React from 'react';
import { Container, Tab, Tabs } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CalendarComponent from '../../../components/calendar/Calendar/Calendar';
import TeamOverview from '../../../components/calendar/TeamOverview/TeamOverview';

const TABS = ["calendar", "team"];

const Calendar = () => {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = TABS.includes(searchParams.get("tab")) ? searchParams.get("tab") : "calendar";

    const handleSelect = (tab) => {
        setSearchParams(tab === "calendar" ? {} : { tab }, { replace: true });
    };

    return (
        <div className="calendar-page-wrapper bg-main">
            <main className="h-100">
                <Container fluid className="h-100 px-4">
                    <Tabs
                        activeKey={activeTab}
                        onSelect={handleSelect}
                        id="calendar-tabs"
                        className="mt-4 custom-tabs"
                        mountOnEnter
                    >
                        <Tab eventKey="calendar" title={t("components.Calendar.tabs.calendar")}>
                            <CalendarComponent variant='full' />
                        </Tab>
                        <Tab eventKey="team" title={t("components.Calendar.tabs.team")}>
                            <div className="pt-4">
                                <TeamOverview />
                            </div>
                        </Tab>
                    </Tabs>
                </Container>
            </main>
        </div>
    );
};

export default Calendar;
